<template>
  <div class="approval-detail">
    <div class="header">
      {{ getDicValue('approval_type', workflowType) }}
    </div>
    <div class="content">
      <div class="side">
        <div class="bar-container">
          <div class="process-bar">
            <div class="process-bar-item" :class="getBarItemClass(item)" v-for="(item, index) in barData" :key="index">
              <div class="header">
                <div class="circle">{{ index + 1 }}</div>
                <div class="title">{{ item.title }}</div>
              </div>
              <div class="content">
                <div class="sub-title" v-for="(obj, j) in item.child" :key="j">
                  <span>{{ obj.key }}</span>
                  <span>{{ obj.val }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="msg-content">
        <div class="inner-content">
          <div>
            <!-- 合同类申请 -->
            <contract-change-device v-if="showVisible === 'change_order_device'" ref="change_order_device" :model="modelData"></contract-change-device>
            <contract-change-sale-device v-if="showVisible === 'change_order_sale_device'" ref="change_order_sale_device" :model="modelData"></contract-change-sale-device>
            <contract-change-afterservice v-if="showVisible === 'change_order_after_service'" ref="change_order_after_service" :model="modelData"></contract-change-afterservice>
            <contract-change-payment v-if="showVisible === 'change_order_payment_period'" ref="change_order_payment_period" :model="modelData"></contract-change-payment>
            <contract-change-startdate v-if="showVisible === 'change_order_rent_time'" ref="change_order_rent_time" :model="modelData"></contract-change-startdate>
            <contract-stop-rent v-if="showVisible === 'change_order_stop_rent'" ref="change_order_stop_rent" :model="modelData"></contract-stop-rent>
            <contract-stop-sale v-if="showVisible === 'change_order_stop_sale'" ref="change_order_stop_sale" :model="modelData"></contract-stop-sale>
            <contract-stop-contract v-if="showVisible === 'change_order_stop_contract'" ref="change_order_stop_contract" :model="modelData"></contract-stop-contract>
            <contract-suspend-use v-if="showVisible === 'change_order_pause_use'" ref="change_order_pause_use" :model="modelData"></contract-suspend-use>
            <contract-stop-test v-if="showVisible === 'change_order_stop_test'" ref="change_order_stop_test" :model="modelData"></contract-stop-test>
            <!-- 财务类申请 -->
            <invoice-apply v-if="showVisible === 'invoice'" ref="invoice" :model="modelData"></invoice-apply>
            <invoice-gored v-if="showVisible === 'red_application'" ref="red_application" :model="modelData"></invoice-gored>
            <invoice-deposit-refund v-if="showVisible === 'deposit_refund'" ref="deposit_refund" :model="modelData"></invoice-deposit-refund>
            <invoice-deposit-refund v-if="showVisible === 'jv_deposit_refund'" ref="jv_deposit_refund" :model="modelData"></invoice-deposit-refund>
            <invoice-deposit-refund v-if="showVisible === 'hq_deposit_refund'" ref="hq_deposit_refund" :model="modelData"></invoice-deposit-refund>
            <invoice-delay-receive v-if="showVisible === 'deferred'" ref="deferred" :model="modelData"></invoice-delay-receive>
            <invoice-rovoke-receive v-if="showVisible === 'withdrawal_payment'" ref="withdrawal_payment" :model="modelData"></invoice-rovoke-receive>
            <invoice-change-state v-if="showVisible === 'change_bill_trade_state'" ref="change_bill_trade_state" :model="modelData"></invoice-change-state>
            <!-- 库存调拨-库存调拨申请单 -->
            <transfer-order-apply v-if="showVisible === 'transfer_order'" ref="transfer_order" :model="modelData"></transfer-order-apply>
            <!-- 库存管理-库存延期申请 -->
            <change-stock-order-apply v-if="showVisible === 'change_stock_order'" ref="change_stock_order" :model="modelData"></change-stock-order-apply>
            <!-- 库存管理-翻新申请 -->
            <change-stock-refurbish v-if="showVisible === 'return_hq_renovate_apply'" ref="return_hq_renovate_apply" :model="modelData"></change-stock-refurbish>
            <!-- 试用订单-申请免收  free_test_fee-->
            <apply-free v-if="showVisible === 'free_test_fee'" ref="free_test_fee" :model="modelData"></apply-free>
            <!-- 库存管理-申请免收 -->
            <apply-free v-if="showVisible === 'free_stock_fee'" ref="free_stock_fee" :model="modelData"></apply-free>
            <!-- 逾期费-申请免收 -->
            <apply-free v-if="showVisible === 'free_overdue_fee'" ref="free_overdue_fee" :model="modelData"></apply-free>
            <!-- 免收违约金 -->
            <apply-free v-if="showVisible === 'free_break_fee'" ref="free_break_fee" :model="modelData"></apply-free>
            <!--dms-设备报废 device_scrap-->
            <device-scrap v-if="showVisible === 'device_scrap'" ref="device_scrap" :model="modelData"></device-scrap>
            <!--asm- modem_service-->
            <offline-service v-if="showVisible === 'modem_service'" ref="modem_service" :model="modelData"></offline-service>
            <!--asm 质量反馈 feedBack -->
            <feed-back v-if="showVisible === 'feed_back'" ref="feed_back" :model="modelData" v-model="form.pass"></feed-back>
            <!--crm-购买数据服务 buy_data_service-->
            <device-buy-service v-if="showVisible === 'sim_service'" ref="sim_service" :model="modelData"></device-buy-service>
          </div>
          <el-form label-position="top" ref="form" :model="form" :rules="rules">
            <template v-if="!showProcess">
              <el-form-item :label="$t('crm_approvalDetail.shen_pi_jie_guo')">
                <el-radio-group v-model="form.pass">
                  <el-radio :label="true">{{ $t('crm_approvalDetail.tong_guo') }}</el-radio>
                  <el-radio :label="false">{{ $t('crm_approvalDetail.bu_tong_guo') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('crm_approvalDetail.shen_pi_yi_jian')" prop="remark">
                <el-input type="textarea" v-model="form.remark"></el-input>
              </el-form-item>
            </template>
          </el-form>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!showProcess">
      <el-button @click="onCancel">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" v-repeat="5000" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <device-acrap-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="successBack"></device-acrap-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import contractChangeDevice from '@/components/approvalCenter/contract_change_device.vue';
import contractChangeSaleDevice from '@/components/approvalCenter/contract_change_sale_device.vue';
import contractChangeAfterservice from '@/components/approvalCenter/contract_change_afterservice.vue';
import contractChangeStartdate from '@/components/approvalCenter/contract_change_startdate.vue';
import contractChangePayment from '@/components/approvalCenter/contract_change_payment.vue';
import contractStopContract from '@/components/approvalCenter/contract_stop_contract.vue';
import contractStopRent from '@/components/approvalCenter/contract_stop_rent.vue';
import contractStopSale from '@/components/approvalCenter/contract_stop_sale.vue';
import contractSuspendUse from '@/components/approvalCenter/contract_suspend_use.vue';
import contractStopTest from '@/components/approvalCenter/contract_stop_test.vue';
import invoiceApply from '@/components/approvalCenter/invoice_apply.vue';
import invoiceGored from '@/components/approvalCenter/invoice_gored.vue';
import invoiceDepositRefund from '@/components/approvalCenter/invoice_deposit_refund.vue';
import invoiceDelayReceive from '@/components/approvalCenter/invoice_delay_receive.vue';
import invoiceRovokeReceive from '@/components/approvalCenter/invoice_revoke_receive.vue';
import invoiceChangeState from '@/components/approvalCenter/invoice_change_state.vue';
import transferOrderApply from '@/components/approvalCenter/transfer_order_apply.vue';
import changeStockOrderApply from '@/components/approvalCenter/change_stock_order_apply';
import applyFree from '@/components/approvalCenter/apply_free';
import deviceScrap from '@/components/approvalCenter/device_scrap';
import offlineService from '@/components/approvalCenter/offline_service';
import deviceAcrapDialog from '@/pages/crm/components/deviceAcrapDialog.vue';
import changeStockRefurbish from '@/components/approvalCenter/change_stock_refurbish';
import feedBack from '@/components/approvalCenter/feed_back';
import deviceBuyService from '@/components/approvalCenter/device_buy_service';

export default {
  name: '',
  mixins: [],
  components: {
    contractChangeDevice,
    contractChangeSaleDevice,
    contractChangeAfterservice,
    contractChangePayment,
    contractChangeStartdate,
    contractStopRent,
    contractStopSale,
    contractStopContract,
    contractSuspendUse,
    contractStopTest,
    invoiceApply,
    invoiceGored,
    invoiceDepositRefund,
    invoiceDelayReceive,
    invoiceRovokeReceive,
    invoiceChangeState,
    transferOrderApply,
    changeStockOrderApply,
    applyFree,
    deviceScrap,
    offlineService,
    deviceAcrapDialog,
    changeStockRefurbish,
    deviceBuyService,
    feedBack,
    // testToRent
  },
  props: {},
  data() {
    return {
      workflowType: '',
      bizId: '',
      applicationBo: {},
      approvalNodeList: [],
      form: {
        pass: true,
        remark: '',
      },
      map: {},
      modelData: {},
      showVisible: '',
      dialogVisible: false,
      dialogModel: {},
      showProcess: false,
    };
  },
  computed: {
    i18n() {
      return {
        label_approval_result: this.$t('crm_approvalDetail.shen_pi_jie_guo'),
        label_approval_remark: this.$t('crm_approvalDetail.shen_pi_yi_jian'),
        page_content_apply: this.$t('crm_approvalDetail.shen_qing'),
        label_apply_user: this.$t('crm_approvalDetail.shen_qing_ren'),
        label_apply_time: this.$t('crm_approvalDetail.shen_qing_shi_jian'),
        label_apply_state: this.$t('crm_approvalDetail.shen_qing_zhuang_tai'),
        label_apply_reason: this.$t('crm_approvalDetail.shen_qing_yuan_yin'),
        label_approver_name: this.$t('crm_approvalDetail.shen_pi_ren'),
        label_approval_time: this.$t('crm_approvalDetail.shen_pi_shi_jian'),
        label_approval_state: this.$t('crm_approvalDetail.shen_pi_zhuang_tai'),
        page_content_pass: this.$t('crm_approvalDetail.tong_guo'),
        page_content_reject: this.$t('crm_approvalDetail.bu_tong_guo'),
      };
    },
    rules() {
      return {
        remark: {
          required: true,
          message: this.$t('Common.com_required'),
        }
      };
    },
    barData() {
      const ret = [];

      const applyItem = {
        title: this.$t('crm_approvalDetail.shen_qing'),
        child: [
          {
            key: this.$t('crm_approvalDetail.shen_qing_ren'),
            val: this.applicationBo.applyUser,
          },
        ],
        flowNodeNo: 0,
      };
      if (this.applicationBo.applyTime) {
        applyItem.child.push({
          key: this.$t('crm_approvalDetail.shen_qing_shi_jian'),
          val: this.momentAmPm(this.$momentLocal(this.applicationBo.applyTime)),
        });
      }
      if (this.applicationBo.applyReason) {
        applyItem.child.push({
          key: this.$t('crm_approvalDetail.sqrssgs'),
          val: this.applicationBo.applyOrgName,
        });
      }
      if (this.applicationBo.approvalState) {
        applyItem.child.push({
          key: this.$t('crm_approvalDetail.shen_qing_zhuang_tai'),
          val: this.getDicValue('crm_contract_approval_state', this.applicationBo.approvalState),
        });
      }
      if (this.applicationBo.applyReason) {
        applyItem.child.push({
          key: this.$t('crm_approvalDetail.shen_qing_yuan_yin'),
          val: this.applicationBo.applyReason,
        });
      }

      ret.push(applyItem);

      // 过滤抄送节点
      const list = this.approvalNodeList.filter((item) => item.approverPerm !== 2);
      const insertList = list.map((item) => {
        const child = [
          {
            key: this.$t('crm_approvalDetail.shen_pi_ren'),
            val: item.approvalLog ? item.approvalLog.approverName : item.approvalRoleName || item.approverNames,
          },
        ];

        if (item.approvalLog) {
          if (item.approvalLog.approvalTime) {
            child.push({
              key: this.$t('crm_approvalDetail.shen_pi_shi_jian'),
              val: this.momentAmPm(this.$momentLocal(item.approvalLog.approvalTime)),
            });
          }
          if (item.approvalLog.approvalState) {
            child.push({
              key: this.$t('crm_approvalDetail.shen_pi_zhuang_tai'),
              val: this.getDicValue('crm_contract_approval_state', item.approvalLog.approvalState),
            });
          }
          if (item.approvalLog.approvalOpinion) {
            child.push({
              key: this.$t('crm_approvalDetail.shen_pi_yi_jian'),
              val: item.approvalLog.approvalOpinion,
            });
          }
        }

        return {
          title: item.flowNodeName,
          child,
          flowNodeNo: item.flowNodeNo,
        };
      });
      ret.push(...insertList);

      return ret;
    },
    userInfo() {
      return this.$store.state.userInfo || {};
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    onCancel() {
      this.$router.back();
    },
    async onConfirm() {
      if (this.showProcess) {
        this.$router.back();
      }

      if (this.showVisible === 'feed_back' && `${this.applicationBo.currentNodeNo}` !== '1') {
        await this.$refs[this.showVisible].onConfirm();
      }

      await this.$refs.form.validate((valid) => {
        if (valid) {
          const basePath = this.form.pass ? apis.apsApproveApprovalAapproveYes : apis.apsApproveApprovalApproveNo;
          const fullPath = `${basePath}/${this.workflowType}/${this.bizId}`;
          const reqData = {
            bizId: this.bizId,
            remark: this.form.remark,
          };
          let bizData = [];
          if (this.showVisible === 'change_order_stop_rent') {
            const list = this.$refs[this.showVisible].selectDevice;
            list.forEach((item) => {
              if (item.endRentDateSource && item.endRentDateSource === item.endRentDate) {
                const str = this.$moment(item.endRentDate).subtract(1, 'seconds').format('YYYY-MM-DD HH:mm:ss');
                item.endRentDate = str;
              }
            });
            bizData = list;
          }
          if (this.showVisible === 'change_order_stop_sale') {
            bizData = this.$refs[this.showVisible].selectDevice;
          }
          if (this.showVisible === 'device_scrap') {
            bizData = this.$refs[this.showVisible].list;
          }
          if (this.showVisible === 'feed_back') {
            bizData = this.$refs[this.showVisible].form;
            bizData.opinion = this.form.remark;
            if (!this.form.pass) {
              reqData.reject2Last = true;
              bizData = [];
            }
          }
          this.$postJSON(
            fullPath,
            {
              ...reqData,
              bizData,
            },
            true
          ).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            // 设备报废 特殊要加多一个弹窗选择 审批结果
            if (this.showVisible === 'device_scrap') {
              // 最后一个审批才选择
              const end = this.approvalNodeList.pop();
              if (end.approverIds === this.userInfo.userId) {
                this.dialogVisible = true;
                this.dialogModel.scrapApplyId = this.bizId;
              }
              this.successBack();
            } else {
              this.successBack();
            }
          });
        }
      });
    },
    successBack() {
      // 通知列表更新
      this.Bus.$emit('/examine/approvalDetail:update');
      this.$router.back();
    },
    getPageInfo() {
      this.$getJSON(`${apis.apsApproveApprovalInfo}/${this.workflowType}/${this.bizId}`).then((res) => {
        const { applicationBo, approvalNodeList } = res.data;
        this.applicationBo = applicationBo;
        this.approvalNodeList = approvalNodeList;

        this.modelData = {
          changeId: this.bizId,
          workflowType: this.workflowType,
          changeType: this.workflowType,
          // 审批的话，申请信息不可修改，故用watch
          type: 'watch',
          approve: true, // 处于审批流中
          showProcess: this.showProcess, // 是否审批完成
          approveCurrentNo: this.applicationBo.currentNodeNo,
        };
        this.showVisible = this.workflowType;
      });
    },
    getBarItemClass(item) {
      if (item.flowNodeNo > this.applicationBo.currentNodeNo) {
        return 'next';
      }
      if (item.flowNodeNo === this.applicationBo.currentNodeNo) {
        return 'cur';
      }
      return 'pre';
    },
  },
  created() {},
  mounted() {
    this.workflowType = this.getJump('workflowType');
    this.bizId = this.getJump('bizId');
    const showProcess = this.getJump('showProcess');
    this.showProcess = typeof showProcess === 'string' ? showProcess === 'true' : !!showProcess;

    this.getPageInfo();
    this.getDictionary('approval_type', (res) => {
      const map = {};
      res.approval_type.forEach((item) => {
        map[item.code] = item.value;
      });
      this.map = map;
    });
  },
};
</script>

<style lang="scss" scoped>
.approval-detail {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;

  $borderColor: #e9ebec;

  > .header {
    height: 50px;
    border-bottom: 1px solid $borderColor;
    background: #fff;
    padding-left: 18px;
    font-size: 14px;
    font-weight: bold;
    color: #495057;
    line-height: 50px;
  }
  > .content {
    flex: 1;
    background: #fff;
    display: flex;
    overflow: hidden;
    > .side {
      width: 314px;
      border-right: 1px solid $borderColor;
      .bar-container {
        height: 100%;
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 24px;

        .process-bar {
          margin-left: 1px;
          margin-top: 4px;

          font-size: 12px;
          .process-bar-item {
            &:last-child {
              .content {
                &::before {
                  display: none;
                }
              }
            }
            &.next {
              .header .circle {
                background: #98a6ad;
              }
              .content {
                &::before {
                  background: #dee2e6;
                }
              }
            }
            &.cur {
              .content {
                &::before {
                  background: #dee2e6;
                }
              }
            }
            .header {
              overflow: hidden;
              .circle {
                float: left;
                width: 17px;
                height: 17px;
                border-radius: 100%;
                background: #4a90e2;
                line-height: 18px;
                text-align: center;
                color: #fff;
              }
              .title {
                float: left;
                color: #495057;
                line-height: 18px;
                margin-left: 12px;
                font-weight: bold;
              }
            }
            .content {
              padding-left: 29px;
              min-height: 58px;
              overflow: hidden;
              position: relative;
              padding-bottom: 32px;

              &::before {
                content: ' ';
                position: absolute;
                width: 1px;
                background: #0d9ae0;
                left: 8px;
                top: 5px;
                bottom: 5px;
              }

              .sub-title {
                color: #6c757d;
                margin-top: 6px;
                line-height: 20px;
              }
            }
          }
        }
      }
    }
    > .msg-content {
      flex: 1;
      overflow-y: auto;
      > .inner-content {
        padding: 24px;
      }
    }
  }
  > .footer {
    height: 50px;
    border-top: 1px solid $borderColor;
    border-bottom: 1px solid $borderColor;
    background: #fff;
    text-align: right;
    padding-top: 8px;
    padding-right: 18px;
  }
}
</style>
